<template>
  <router-link
    :to="`/topic/${topicId}`"
    class="topic-badge"
    :class="{ 'topic-badge-large': size === 'large' }"
  >
    <span class="topic-icon">{{ icon }}</span>
    <span class="topic-name">{{ name }}</span>
  </router-link>
</template>

<script>
export default {
  name: "TopicBadge",
  props: {
    topicId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "medium", // medium, large
    },
  },
};
</script>

<style scoped>
.topic-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.1),
    rgba(139, 92, 246, 0.1)
  );
  border: 1.5px solid rgba(59, 130, 246, 0.3);
  border-radius: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.topic-badge::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.15),
    rgba(139, 92, 246, 0.15)
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.topic-badge:hover::before {
  opacity: 1;
}

.topic-badge:hover {
  border-color: rgba(59, 130, 246, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.topic-icon {
  font-size: 14px;
  line-height: 1;
  transition: transform 0.3s ease;
}

.topic-badge:hover .topic-icon {
  transform: scale(1.15) rotate(-5deg);
}

.topic-name {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  letter-spacing: 0.02em;
  transition: color 0.3s ease;
}

.topic-badge:hover .topic-name {
  color: #3b82f6;
}

/* Large size variant */
.topic-badge-large {
  padding: 7px 16px;
  gap: 8px;
}

.topic-badge-large .topic-icon {
  font-size: 16px;
}

.topic-badge-large .topic-name {
  font-size: 14px;
}

@media (min-width: 640px) {
  .topic-badge {
    padding: 6px 14px;
  }

  .topic-icon {
    font-size: 15px;
  }

  .topic-name {
    font-size: 13px;
  }

  .topic-badge-large {
    padding: 8px 18px;
  }

  .topic-badge-large .topic-icon {
    font-size: 17px;
  }

  .topic-badge-large .topic-name {
    font-size: 15px;
  }
}
</style>
